import * as S from "./style";
import * as React from "react";
import { theme } from "styles/theme";
import { SubtleButton } from "components/button";

type Tab = {
  tab: React.ReactNode;
  count?: string | number | null;
  content?: React.ReactElement;
  hide?: boolean;
  unSelectable?: boolean;
  buttons?: React.ReactNode;
};

type Props = {
  data: { [key: string]: Tab } | null;
  defaultTab?: string;
  onClick?: (key: string) => void;
  content?: React.ReactNode;
  headerOnly?: boolean;
  style?: {
    main?: {};
    tab?: {};
    content?: {};
  };
  buttons?: React.ReactNode;
  setExportType?: (key: string) => void;
  useSticky?: boolean;
};
export default function Tab({
  data,
  defaultTab,
  onClick,
  content,
  style,
  useSticky = false,
  ...props
}: Props) {
  const [selected, setSelected] = React.useState<string | undefined>(
    defaultTab
  );

  const contentRender =
    !props.headerOnly &&
    ((selected && data && data[selected]?.content) || content);

  React.useEffect(() => {
    if (defaultTab) {
      setSelected(defaultTab);
    } else if (data) {
      let key = Object.keys(data)[0];
      setSelected(key);
      onClick && onClick(key);
    }
  }, [defaultTab /* //?data*/]);

  const selectedTabRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (selectedTabRef.current) {
      selectedTabRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  }, [selected]);

  const populateTabs =
    data &&
    Object.entries(data)
      .filter(([key, value]) => !value.hide)
      .map(([key, value]) => {
        if (value.unSelectable) {
          return value.tab;
        }

        const handleClick = (key: string) => {
          setSelected(key);
          props.setExportType && props.setExportType(key);
          onClick && onClick(key);
        };

        const isSelected = selected === key;
        return (
          <S.TabButton
            {...{ key, isSelected }}
            ref={isSelected ? selectedTabRef : null}
            onClick={() => handleClick(key)}
            className=""
          >
            <SubtleButton
              className={`!p-0 !px-3 ${isSelected && "!text-[#ff4f00]"}`}
            >
              {value.tab}
              {(value.count || value.count === 0) && (
                <span
                  style={{
                    color: theme.color.main,
                    fontSize: "0.8rem",
                    marginLeft: "0.4rem",
                  }}
                >
                  {value.count}
                </span>
              )}
            </SubtleButton>
            {value.buttons || null}
          </S.TabButton>
        );
      });

  const tabContainerClassName = props.headerOnly ? "!border-b-0" : "";

  return (
    <S.Con style={{ ...style?.main }}>
      {useSticky ? (
        <S.TabConSticky
          style={style?.tab}
          className={tabContainerClassName}
        >
          {populateTabs}
          {props.buttons && <div className="ml-auto">{props.buttons}</div>}
        </S.TabConSticky>
      ) : (
        <S.TabCon
          style={style?.tab}
          className={tabContainerClassName}
        >
          {populateTabs}
          {props.buttons && <div className="ml-auto">{props.buttons}</div>}
        </S.TabCon>
      )}
      {contentRender && (
        <S.ContentCon style={{ ...style?.content }}>
          {contentRender}
        </S.ContentCon>
      )}
    </S.Con>
  );
}
